define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/userListFootnoteView.tmpl");
    var Dropdown = require('ui/dropdown/Dropdown');
    var InputField = require('ui/input-field/InputField');
    var Notifier = require("ui/notifier/Notifier");
    var Media = require("media");
    var storage = require("assets/js/storage");
    var SettingsCollection = require("collections/SettingsCollection");
    var LanguageManager =  require("LanguageManager");
    var Loader = require("ui/loader/Loader");
    var ERROR_CODES = require("codeTables/errorCodes.json");

    var DROPDOWN_STATE = {
        SHOW : "show",
        HIDE : "hide"
    };
    var USER_MANAGEMENT_FOOTNOTE = "_USER_MANAGEMENT_FOOTNOTE";
    var UserListFootnoteView = {};
    var that;

    LE.module('LEUserManagement', function (LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserListFootnoteView = Marionette.Layout.extend({

            template : template,

            events: {
                "click .close-button": "hideFootnote",
                "click .pushpin-button": "showFootnote"
            },
            ui:{
                wrapper:".footnote-wrapper",
                slaContainer: '.sla-container'
            },
            regions: {
                languageDropdownRegions: '.language-dropdown',
                timezoneDropdownRegions: '.timezone-dropdown',
                timeoutDropdownRegions: '.timeout-dropdown',
                maxConversationsRegions: '.max-conversations'
            },

            initialize: function(options){
                LEUserManagement.logger.info("UserListFootnoteView >> initialize >> START");
                this.collection = options.collection;
                that = this;
                LEUserManagement.logger.info("UserListFootnoteView >> initialize >> END");
            },

            hideFootnote: function(){
                LEUserManagement.logger.info("UserListFootnoteView >> hideFootnote >> START");
                storage.set(this._getLocalStorageKey(), DROPDOWN_STATE.HIDE);
                this.ui.wrapper.addClass("close");
                LEUserManagement.logger.info("UserListFootnoteView >> hideFootnote >> END");
            },

            showFootnote: function(){
                LEUserManagement.logger.info("UserListFootnoteView >> showFootnote >> START");
                storage.set(this._getLocalStorageKey(), DROPDOWN_STATE.SHOW);
                this.ui.wrapper.removeClass("close");
                LEUserManagement.logger.info("UserListFootnoteView >> showFootnote >> END");
            },

            onRender: function () {
                LEUserManagement.logger.info("UserListFootnoteView >> onRender >> START");
                if(!this.collection || this.collection.length === 0) {
                    this.ui.wrapper.addClass("hidden");
                    return;
                }

                var initState = storage.get(this._getLocalStorageKey());
                if (initState && initState === DROPDOWN_STATE.HIDE) {
                    this.hideFootnote();
                } else {
                    this.showFootnote();
                }
                var hasEditSiteSettingPrivilege = LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_SITE_SETTING);
                this.languageDropDown = new Dropdown({
                    name: 'language',
                    permutation:Dropdown.PERMUTATION.SMALL1,
                    selectedOption: this._getSelectedLanguage(),
                    items: this._getLanguageOptions(),
                    enabled: hasEditSiteSettingPrivilege,
                    testCollision: true,
                    collisionWithinSelector: '.le .um .um-main-region-container .users-grid-container'
                });
                this.listenTo(this.languageDropDown, Dropdown.TRIGGERING.CHANGE, onLanguageChange, this);
                this.languageDropdownRegions.show(this.languageDropDown);

                this.timezoneDropDown = new Dropdown({
                    name: 'timezone',
                    permutation: Dropdown.PERMUTATION.XXX_SMALL3,
                    selectedOption: this._getSelectedTimezone(),
                    items: this._getTimezoneOptions(),
                    enabled: hasEditSiteSettingPrivilege,
                    testCollision: true,
                    collisionWithinSelector: '.le .um .um-main-region-container .users-grid-container'
                });
                this.listenTo(this.timezoneDropDown, Dropdown.TRIGGERING.CHANGE, onTimezoneChange, this);
                this.timezoneDropdownRegions.show(this.timezoneDropDown);

                this.timeoutDropDown = new Dropdown({
                    name: 'timeout',
                    permutation: Dropdown.PERMUTATION.X_SMALL1,
                    selectedOption: this._getSelectedTimeout(),
                    items: this._getTimeoutOptions(),
                    enabled: hasEditSiteSettingPrivilege,
                    testCollision: true,
                    collisionWithinSelector: '.le .um .um-main-region-container .users-grid-container'
                });
                this.listenTo(this.timeoutDropDown, Dropdown.TRIGGERING.CHANGE, onTimeoutChange, this);
                this.timeoutDropdownRegions.show(this.timeoutDropDown);

                var isMessagingState = this._isMessagingState();
                this.ui.slaContainer.toggleClass("show", isMessagingState);
                if(isMessagingState) {
                    this.maxConversationsInputField = new InputField({
                        type: "text",
                        permutation: InputField.Permutation.J2,
                        placeholder: "",
                        maxLength: "3",
                        disabled: !hasEditSiteSettingPrivilege,
                        value: this._getSelectedTMaxConversations()
                    });
                    this.listenTo(this.maxConversationsInputField, InputField.TRIGGERING.ONBLUR, saveMaxConversations);
                    this.listenTo(this.maxConversationsInputField, InputField.TRIGGERING.ENTER_PRESSED, saveMaxConversations);
                    this.maxConversationsRegions.show(this.maxConversationsInputField);
                }
                LEUserManagement.logger.info("UserListFootnoteView >> onRender >> END");
            },

            //update all settings with updated site settings values
            //todo this should be activated by collection fetch:success not by call from outside
            //todo and maybe on fetch:loading show loader or hide the whole thing ( product req)
            updateSettings: function() {
                this.languageDropDown.setSelection(this._getSelectedLanguage(), {silent: true});
                this.timezoneDropDown.setSelection(this._getSelectedTimezone(), {silent: true});
                this.timeoutDropDown.setSelection(this._getSelectedTimeout(), {silent: true});

                if (this._isMessagingState()) {
                    this.maxConversationsInputField.setValue(this._getSelectedTMaxConversations());
                }
            },

            _getLanguageOptions: function() {
                LEUserManagement.logger.info("UserListFootnoteView >> _getLanguageOptions >> START");
                var languageList = LE.siteSettings.languageSettings.getLanguageListTranslated();
                LEUserManagement.logger.info("UserListFootnoteView >> _getLanguageOptions >> END");
                return new Dropdown.Collection(languageList);
            },

            _getSelectedLanguage: function() {
                LEUserManagement.logger.info("UserListFootnoteView >> _getSelectedLanguage >> START / END");
                return that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.LOCALE).getValue();
            },

            _getTimezoneOptions: function() {
                LEUserManagement.logger.info("UserListFootnoteView >> _getTimeoutOptions >> START");
                var timeZoneList = LE.siteSettings.timeZoneSettings.getTimeZoneListTranslated();

                _.each(timeZoneList, function(item){
                    item.searchKey = item.value.substring(12,item.value.length).trim().toLowerCase();
                });

                LEUserManagement.logger.info("UserListFootnoteView >> _getTimeoutOptions >> END");
                return new Dropdown.Collection(timeZoneList);
            },

            _getTimeoutOptions: function() {
                var timeoutList = LE.siteSettings.sessionTimeoutSettings.getSessionTimeoutListTranslated();
                return new Dropdown.Collection(timeoutList);
            },

            _getSelectedTimezone: function() {
                LEUserManagement.logger.info("UserListFootnoteView >> _getSelectedTimezone >> START / END");
                return that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.TIME_ZONE).getValue();
            },

            _getSelectedTimeout: function() {
                LEUserManagement.logger.info("UserListFootnoteView >> _getSelectedTimeout >> START / END");
                return that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.SESSION_TIMEOUT).getValue();
            },

            _getSelectedTMaxConversations: function() {
                LEUserManagement.logger.info("UserListFootnoteView >> _getSelectedTMaxConversations >> START / END");
                return that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS).getValue();
            },

            _getLocalStorageKey : function () {
                var accountId = LE.sessionManager.getAccountId();
                var userId = LE.sessionManager.getUserId();
                var localStorageKey = accountId + "_" + userId + USER_MANAGEMENT_FOOTNOTE;

                return localStorageKey;
            },

            _isMessagingState: function() {
                return LE.sessionManager.hasAsyncMessagingFeature();
            }
        });

        function saveMaxConversations(val) {
            LEUserManagement.logger.info("UserListFootnoteView >> saveMaxConversations >> START");
            var maxConversations = _getInputFieldVal(val);
            _updateCollection(maxConversations, SettingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS, that.maxConversationsInputField);
            LEUserManagement.logger.info("UserListFootnoteView >> saveMaxConversations >> END");
        }

        function _getInputFieldVal(val){
            if (val && val.value) {
                return val.value;  // When pressing "enter" an object is sent instead of only value on blur.
            } else {
                return val;
            }
        }

        function _updateCollection(value, CollectionValue, inputFieldInstance) {
            var modelInCollectionToUpdate = that.collection.get(CollectionValue);
            var lastMaxConversationsValue = modelInCollectionToUpdate.getValue();
            var options = {
                success : function() {
                    hideLoader();
                },
                error: function(collection, response, options) {
                    hideLoader();
                    modelInCollectionToUpdate.setValue(lastMaxConversationsValue);
                    inputFieldInstance.setValue(lastMaxConversationsValue);
                    _showNotifierError(response);
                }
            };
            if (!isNaN(value) && parseInt(value, 10) >= 0) {
                if (lastMaxConversationsValue.toString() === value) {
                    return;
                } else {
                    showLoader();
                    modelInCollectionToUpdate.setValue(value);
                    modelInCollectionToUpdate.save(null, options);
                }
            } else {
                inputFieldInstance.setValue(lastMaxConversationsValue);
                LEUserManagement.notifier.showError(LE.translator.translate("LEUserManagement.error.update.settings"));
            }
            return;
        }

        function onLanguageChange(selectionContext){
            LEUserManagement.logger.info("UserListFootnoteView >> onLanguageChange >> START");
            if(selectionContext.oldKey !== selectionContext.selectedKey) {
                var vent = Media.vent();
                LEUserManagement.notifier.showConfirm({
                    title: LE.translator.translate('LEFramework.global.captions.are.you.sure'),
                    content: LE.translator.translate('LEUserManagement.userList.footnote.change.confirm.text'),
                    vent: vent,
                    objectAction: {
                        text: LE.translator.translate('LEFramework.global.captions.ok'),
                        callback:function() {
                            _saveLanguage(that, that.languageDropDown, selectionContext);
                        },
                        cancelCallback: function(){
                            _setDropDownSelection (that.languageDropDown, selectionContext);
                        }
                    }
                });
            }
            LEUserManagement.logger.info("UserListFootnoteView >> onLanguageChange >> END");
        }

        function _setDropDownSelection(dropdown, selectionContext) {
            var options = {silent: true};
            dropdown.setSelection(selectionContext.oldKey, options);
        }

        function _saveTimezone(releventDropdown, selectionContext) {
            LEUserManagement.logger.info("UserListFootnoteView >> _saveTimezone >> START");
            showLoader();
            var modelInCollectionToUpdate = that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.TIME_ZONE);
            var timezone = selectionContext.selectedKey;
            var options = {
                success : function() {
                    LE.siteSettings.timeZoneSettings.switchTimeZone(timezone);
                    hideLoader();
                },
                error: function(collection, response, options) {
                    modelInCollectionToUpdate.setValue(selectionContext.oldKey);
                    _setDropDownSelection (releventDropdown, selectionContext);
                    hideLoader();
                    _showNotifierError(response);
                }
            };
            modelInCollectionToUpdate.setValue(timezone);
            modelInCollectionToUpdate.save(null, options);
            LEUserManagement.logger.info("UserListFootnoteView >> _saveTimezone >> START");
        }

        function _saveTimeout(releventDropdown, selectionContext) {
            LEUserManagement.logger.info("UserListFootnoteView >> _saveTimeout >> START");
            showLoader();
            var modelInCollectionToUpdate = that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.SESSION_TIMEOUT);
            var timeout = selectionContext.selectedKey;
            var options = {
                success : function() {
                    LE.siteSettings.sessionTimeoutSettings.switchSessionTimeout(timeout);
                    hideLoader();
                },
                error: function(collection, response, options) {
                    modelInCollectionToUpdate.setValue(selectionContext.oldKey);
                    _setDropDownSelection (releventDropdown, selectionContext);
                    hideLoader();
                    _showNotifierError(response);
                }
            };
            modelInCollectionToUpdate.setValue(timeout);
            modelInCollectionToUpdate.save(null, options);
            LEUserManagement.logger.info("UserListFootnoteView >> _saveTimeout >> START");
        }

        function onTimezoneChange(selectionContext){
            LEUserManagement.logger.info("UserListFootnoteView >> onTimezoneChange >> START");
            if(selectionContext.oldKey !== selectionContext.selectedKey) {
                LEUserManagement.notifier.showConfirm({
                    title: LE.translator.translate('LEFramework.global.captions.are.you.sure'),
                    content: LE.translator.translate('LEUserManagement.userList.footnote.change.confirm.text'),
                    objectAction: {
                        text: LE.translator.translate('LEFramework.global.captions.ok'),
                        callback: function() {
                            _saveTimezone(that.timezoneDropDown, selectionContext);
                        },
                        cancelCallback: function(){
                            _setDropDownSelection (that.timezoneDropDown, selectionContext);
                        }
                    }
                });
            }
            LEUserManagement.logger.info("UserListFootnoteView >> onTimezoneChange >> END");
        }

        function onTimeoutChange(selectionContext){
            LEUserManagement.logger.info("UserListFootnoteView >> onTimeoutChange >> START");
            if(selectionContext.oldKey !== selectionContext.selectedKey) {
                LEUserManagement.notifier.showConfirm({
                    title: LE.translator.translate('LEFramework.global.captions.are.you.sure'),
                    content: LE.translator.translate('LEUserManagement.userList.footnote.change.confirm.text'),
                    objectAction: {
                        text: LE.translator.translate('LEFramework.global.captions.ok'),
                        callback: function() {
                            _saveTimeout(that.timeoutDropDown, selectionContext);
                        },
                        cancelCallback: function(){
                            _setDropDownSelection (that.timeoutDropDown, selectionContext);
                        }
                    }
                });
            }
            LEUserManagement.logger.info("UserListFootnoteView >> onTimezoneChange >> END");
        }

        function _saveLanguage(that, releventDropdown,selectionContext) {
            LEUserManagement.logger.info("UserListFootnoteView >> _saveLanguage >> START");
            showLoader();
            var lang = selectionContext.selectedKey;
            var modelInCollectionToUpdate = that.collection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.LOCALE);
            var languageManager = new LanguageManager();
            var options = {
                success : function() {
                    languageManager.reload();
                    hideLoader();
                },
                error: function(model, response, options) {
                    modelInCollectionToUpdate.setValue(selectionContext.oldKey);
                    _setDropDownSelection (releventDropdown, selectionContext);
                    hideLoader();
                    _showNotifierError(response);
                }
            };
            modelInCollectionToUpdate.setValue(lang);
            modelInCollectionToUpdate.save(null, options);
            LEUserManagement.logger.info("UserListFootnoteView >> _saveLanguage >> END");
        }

        function _showNotifierError(response) {
            if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision) {
                LEUserManagement.notifier.showError(LE.translator.translate("LEUserManagement.userList.footnote.change.error.anotherUser"));
            } else {
                LEUserManagement.notifier.showError(LE.translator.translate("LEUserManagement.userList.footnote.change.error.generic"));
            }
        }

        function showLoader(){
            if (!that.loader){
                that.loader = new Loader({
                    permutation: Loader.PERMUTATION.A,
                    el: '.footnote'
                });
            }
            that.loader.render();
        }

        function hideLoader(){
            if (that.loader){
                that.loader.close();
            }
        }
    });


    return UserListFootnoteView;
});
